'use-client';
import EyeIcon from '@/component-library/svg/eye.svg';
import React, { ComponentProps } from 'react';

export const Wink: React.FC<ComponentProps<typeof EyeIcon>> = ({
  ...props
}) => {
  const speed = '0.6s';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 -3 18 18"
      fill="black"
      width={props.width || 24}
    >
      <circle className="pupil" cx="9" cy="6" r="3.5" mask="url(#light)" />
      <path
        id="bottom-lid"
        d="M16.4,6c-1.5,2.8-4.4,4.5-7.4,4.5s-5.9-1.7-7.4-4.5H0c0,0,0,.3.1.5,1.7,3.3,5,5.5,8.9,5.5s7.2-2.2,8.9-5.5c0,0,.1-.3.1-.5h-1.6Z"
      />

      <path
        id="top-lid"
        d="M1.6,6C3.1,3.2,5.9,1.5,9,1.5s5.9,1.7,7.4,4.5h1.6c0,0,0-.3-.1-.5C16.2,2.2,12.9,0,9,0S1.8,2.2.1,5.5c0,0-.1.3-.1.5h1.6Z"
      >
        <animateTransform
          id="anim1"
          begin="indefinite"
          className="ani-trigger"
          attributeName="transform"
          type="translate"
          values="0 0; 0 12; 0 0"
          dur={speed}
          fill="freeze"
        />
        <animateTransform
          id="anim2"
          begin="indefinite"
          className="ani-trigger"
          attributeName="transform"
          additive="sum"
          type="scale"
          values="1 1; 1 -1; 1 1"
          dur={speed}
          fill="freeze"
        />
      </path>

      <mask id="light">
        <rect width="100%" height="100%" fill="white" />
        <circle id="light-mask" cx="6.4" cy="3.5" r="1.8" fill="#000" />
        <rect id="close-eye2" width="8" height="8" x="5" y="-6.5" fill="#000" />
      </mask>
      <animate
        begin="indefinite"
        className="ani-trigger"
        href="#close-eye2"
        attributeName="y"
        values="-6.5;2;-6.5"
        dur={speed}
        fill="freeze"
      />
    </svg>
  );
};
